<template>
  <div>
    <Preview :dataContract="dataContract" :srcPDF="srcPDF" canBack></Preview>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { ContractService } from '@/services/contract.service'
  import { ReviewService } from '@/services/review.service'
  import Preview from '@/pages/contract/component/preview/preview'
  export default {
    data() {
      return {
        showLoading: true,
        dataContract: {},
        srcPDF: null,
      }
    },
    components: { Preview },
    async created() {
      try {
        const query = this.$route.query
        const param = this.$route.params
        const token = query.token || param.token
        const contractId =
          query.contractID ||
          query.contractid ||
          query.contractId ||
          param.contractId ||
          param.contractid ||
          param.contractID
        if (!contractId) {
          this.showFailMx('Thông tin không hợp lệ , ID hợp đồng không hợp lệ!')
          return
        }
        let dataContractRespon = {}
        if (token) {
          dataContractRespon = await ContractService.previewAndPdf2({
            econtractId: contractId,
            token: token,
            type: 'PREVIEW',
          })
        } else {
          dataContractRespon = await ContractService.previewAndPdf({
            econtractId: contractId,
            type: 'PREVIEW',
          })
        }
        if (dataContractRespon.code === 1000) {
          this.dataContract = dataContractRespon.data
          if (this.dataContract.typeCustomer && this.dataContract.typeCustomer === 'COMPANY') {
            await this.getLinkPDFBusinessContract()
          }
        } else {
          this.showFailMx('Mã hợp đồng không hợp lệ !')
        }
      } catch (err) {
        this.showFailMx(err)
      } finally {
        this.showLoading = false
      }
    },
    methods: {
      async getLinkPDFBusinessContract() {
        try {
          const query = this.$route.query
          const param = this.$route.params
          const token = query.token || param.token
          let data = {}
          if (token) {
            data = await ReviewService.getLinkPDFBusinessContract({
              contractId: this.dataContract.id,
              appendixId: '',
              token: token,
            })
          } else {
            data = await ContractService.getLinkPDFBusinessContract({
              contractId: this.dataContract.id,
              appendixId: '',
            })
          }
          if (data.code === 1000) {
            const start = data.message.indexOf('accessKeyS3=')

            const accessKeyS3 = data.message.substring(start + 12, data.message.length)

            const body = {
              contractId: this.dataContract.id,
              accessKeyS3: accessKeyS3,
            }

            const dataContractRespon = await ContractService.getLinkPDF(body)
            if (dataContractRespon.success) {
              this.srcPDF = `${dataContractRespon.data.urlContractS3}?key=${accessKeyS3}`
            }
          } else {
            console.log(data.message)
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>
